import { httpV1 as http } from '@/services/api';

export async function findOne(key) {
  return http.get(`/shared/cache/${key}`);
}

export async function deleteBy(key) {
  return http.delete(`/shared/cache/${key}`);
}

// Rota própria (/dashboard/cache), diferente do /shared/cache acima.
export async function deleteByDocument(document) {
  if (!document) return Promise.reject(Error('Document not found'));
  return http.delete(`/dashboard/cache/${document}`);
}
